export default __webpack_public_path__ + "static/media/conteblogpic.34dedd40.png";